import React from "react";
import Headers from "../../Components/Headers";

function Prints() {
  return (
    <div className="comingsoon-wrap">
      <Headers />

      <div className="comingsoon-content">
        <h1 className="comingsoon-title">Coming Soon</h1>

        <p className="comingsoon-subtitle">
          We're building something beautiful for you.  
          Stay tuned for updates.
        </p>

        <div className="comingsoon-loader"></div>
      </div>
    </div>
  );
}

export default Prints;
